import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=b95dd9a8&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImage: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/ProfileImage.vue').default,ProgressCircle: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/progress-bars/ProgressCircle.vue').default,SidebarItem: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/navigation/sidebar/SidebarItem.vue').default,ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/buttons/ButtonPrimary.vue').default,DateTimeDisplay: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/DateTimeDisplay.vue').default})
